module.exports = __webpack_public_path__ + "img/getcode-1.34a33216.png";